import React, { useState, useEffect, useRef } from "react";
import { instance } from "../../axios";
import { rupees } from "../../helper";
import { UiActioButton, UiAvatarGroup, UiInput, UiRSelect, UiButton, BgLoader, UiTextArea, UiToggle, UiPopover, UiTFind } from "../../ui";
import { Link, useNavigate, useParams, useLocation, Outlet, useOutletContext } from "react-router-dom";
import { Uploader, DocList } from "../../uploader";



export default function ServiceFiles() {
  const [pstate, setPSate] = useOutletContext();
  const [bg_loader, setBGLoader] = useState(false);
  const [state, setState] = useState({ count: 0 });




  const fetchData = () => {
    instance
      .get("/service_files?id=" + pstate.service.id)
      .then(function (response) {
        setState({ ...state, ...response.data });


      })
      .catch(function (error) { })
      .then(function () { });

  }

  useEffect(() => {
    fetchData();
  }, []);



  return (
    <div className="card card-default">
      <div className="card-body">
          <>
            {state.documents ? (

              <div>
                <h2 className="fs-4">Upload</h2>
                <div className="mb-3">
                  <Uploader category="service" uid={pstate.service.id} onSave={(e) => setState(prevState => ({ documents: [...prevState.documents, ...e] }))} />
                </div>


                {state.documents ? (
                  <div className="mt-4">
                    {state.documents.length > 0 && (
                                        <h2 className="fs-4">Uploaded Files</h2>

                    )}
                  <DocList category="service" setData={(e) => setState({ ...state, documents: e })} data={state.documents} can_edit={1} />
                  </div>
                ) : <BgLoader />}


              </div>
            ) : <BgLoader />}
          </>
      
      </div>
    </div>
  )

}

